// extracted by mini-css-extract-plugin
module.exports = {"wallet-gift-cards-landing":"wallet-gift-cards-landing_wallet-gift-cards-landing__oZGUG","panel":"wallet-gift-cards-landing_panel__1qfoF"};